import { useLocation } from '@tanstack/react-router';
import { SupportDetails } from '@Components/supportDetails/SupportDetails';
import { Icon, Icons } from '@Components/icon/Icon.tsx';
import { menuMap, useSidebarLogic } from '@Components/happyFlowTemplate/sidebarUtils.ts';

export interface IPasswordlessDesktopSideBarItem {
  name: string;
  isActive: boolean;
  isPrevious: boolean;
  number: number;
}

const PasswordlessDesktopSideBarItem = ({
  name,
  isActive,
  isPrevious,
  number,
}: IPasswordlessDesktopSideBarItem) => {
  return (
    <li>
      <div className='flex items-center gap-[8px]'>
        {isPrevious ? (
          <Icon icon={Icons.IcColoredCircleCheckmark} className=' object-cover' />
        ) : (
          <div
            className={`w-[28px] h-[28px] text-center items-center  justify-center rounded-full px-[4px] pt-[2px] text-text-main-primary-inverse text-[16px] ${isActive ? 'bg-surface-brand-action-03' : ' bg-surface-primary-bw-06'}`}>
            {number}
          </div>
        )}

        <h1
          className={`font-metricRSemibold text-[18px] ${isActive ? 'text-text-brand-primary' : isPrevious ? 'text-text-main-tertiary-inverse' : 'text-text-main-tertiary'}`}>
          {name}
        </h1>
      </div>
    </li>
  );
};

export const PasswordlessDesktopSideBar = () => {
  const { pathname } = useLocation();
  const { shouldShowItems, activeRouteIndex } = useSidebarLogic(pathname, menuMap);

  return (
    <div className='z-50 justify-center px-[32px] pt-[56px] pb-[32px] min-w-[270px] w-[270px] xl:w-[400px] bg-surface-primary-bw-00 border-r border-outline-primary-bw-03 h-full hidden sm:flex'>
      <div className='flex flex-col w-full gap-[40px] h-full justify-between'>
        <ul className='gap-[12px] flex flex-col'>
          {shouldShowItems &&
            menuMap.map((item, index: number) => (
              <PasswordlessDesktopSideBarItem
                isActive={index === activeRouteIndex}
                isPrevious={index < activeRouteIndex}
                name={item.name}
                number={index + 1}
                key={index}
              />
            ))}
        </ul>
        <SupportDetails shouldShowLogo />
      </div>
    </div>
  );
};
